// const ww = window.innerWidth
// const wh = window.innerHeight

const animations = {
  // guide: [
  //   {
  //     delay: 0,
  //     duration: 1,
  //     from: { y: wh * 0.5 },
  //     to: { yoyo: true, repeat: -1, ease: 'easeOut', y: wh * 0.48 }
  //   }
  // ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/textsAnimations.js